import type { HotelPreferences, ServiceRequirement } from "./definitions";
import { BoardTypeMapping } from "./definitions";

function OwnArrangement() {
  return (
    <span className="OwnArrangement text-xs border-purple-500 border-2 rounded-md px-1 text-purple-500 font-bold self-start">
      Own Arrangement
    </span>
  );
}

type QuotationAccommodationProps = {
  accommodations: ServiceRequirement[];
  excludedServiceUids: Set<string>;
  excludeSrv: (uid: string) => void;
  includeSrv: (uid: string) => void;
};

export function QuotationAccommodation({
  accommodations,
  excludedServiceUids,
  excludeSrv,
  includeSrv,
}: QuotationAccommodationProps) {
  if (accommodations.length === 0) return null;

  return (
    <div className="rounded-md p-1 px-2 border border-red-300">
      <span>
        <strong>Accommodation: </strong>
      </span>
      <div className="grid gap-1 p-2">
        {accommodations.map((a, idx) => {
          const preferences = a.preferences as HotelPreferences;
          return (
            <div key={`${idx}-${a.notes}`} className="bg-red-100 rounded-md p-1 px-2 grid gap-1">
              <span className="inline-grid grid-cols-[max-content_1fr_max-content_max-content] gap-1">
                <strong>{idx + 1}. </strong>
                <span>{a.notes}</span>
                {preferences.client_own_arrangement ? <OwnArrangement /> : <div />}
                <input
                  type="checkbox"
                  checked={!excludedServiceUids.has(a.uid)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      includeSrv(a.uid);
                    } else {
                      excludeSrv(a.uid);
                    }
                  }}
                />
              </span>
              <div className="grid grid-flow-col gap-1 auto-cols-max">
                {!!preferences.hotel?.label && (
                  <span className="border border-red-300 rounded-md p-1">
                    <strong>Hotel: </strong>
                    {preferences.hotel.label}
                  </span>
                )}
                <span className="border border-red-300 rounded-md p-1">
                  <strong>Board: </strong>
                  {preferences.board.map((b) => BoardTypeMapping[b]).join(", ")}
                </span>
                <span className="border border-red-300 rounded-md p-1">
                  <strong>Rating: </strong>
                  {preferences.rating.join(", ")}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
